import styled, { css } from 'styled-components';

import { grey3 } from 'approot/shared/styles/colours.style';
import { rem } from 'approot/shared/style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';
import { ComponentActions } from '../components.style';
import { ACTIVITY_BUILDER_RIVE_BUTTONS_Z_INDEX } from 'approot/activity-builder/activity-builder.constants';

type RiveViewProps = {
  $isExpanded: boolean;
};

export const RiveView = styled.div<RiveViewProps>`
  height: 100%;
  position: relative;

  // The expanded site fills a modal that supplies its own surface, so the
  // inline site's card treatment would double it up.
  ${({ $isExpanded }) =>
    !$isExpanded &&
    css`
      background-color: ${grey3};
      border-radius: ${rem(borderRadius8)};
      overflow: hidden;
    `}
`;

export const RiveButtons = styled(ComponentActions)`
  z-index: ${ACTIVITY_BUILDER_RIVE_BUTTONS_Z_INDEX};
`;
